import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getEmployee, updateEmployee } from "../../actions/employeeActions";
import {
  Grid,
  TextField,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import Form from "./Form";
import clothingSizes from "../../data/clothingSizes";

import { KeyboardDatePicker } from "@material-ui/pickers";

let credentials = JSON.parse(localStorage.getItem("credentials"));

class UpdateEmployeeForm extends Component {
  state = {
    firstName: "",
    lastName: "",
    bsnNumber: "",
    birthday: null,
    email: "",
    phone: "",
    street: "",
    streetNumber: "",
    zipcode: "",
    city: "",
    emergencyPerson: "",
    emergencyPhone: "",
    clothingPoloSize: "",
    clothingCombatJeansSize: "",
    clothingGiletSize: "",
    clothingShirtSize: "",
    clothingBlouseSize: "",
    clothingPantSize: "",
    clothingShoeSize: "",
  };

  componentDidMount() {
    this.props.getEmployee(this.props.employeeEmail).then((response) => {
      this.setState(response);
    });
  }

  updateEmployee = (e) => {
    e.preventDefault();
    this.props.updateEmployee(this.props.employeeEmail, this.state);
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    return (
      <Form
        onSubmit={this.updateEmployee}
        submitText="Wijzigen"
        isFetching={this.props.isFetching}
        successMessage={this.props.successMessage}
        errorMessage={this.props.errorMessage}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              id="firstName"
              name="firstName"
              label="Naam *"
              value={this.state.firstName}
              onChange={this.handleChange}
              disabled={!credentials.user.isAdmin}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="lastName"
              name="lastName"
              label="Achternaam *"
              value={this.state.lastName}
              onChange={this.handleChange}
              disabled={!credentials.user.isAdmin}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="bsnNumber"
              name="bsnNumber"
              label="BSN-nummer *"
              value={this.state.bsnNumber}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KeyboardDatePicker
              clearable
              mask="__-__-____"
              id="birthday"
              name="birthday"
              label="Geboortedatum *"
              value={this.state.birthday}
              format={"L"}
              onChange={(m) => this.setState({ birthday: m })}
              disabled={!credentials.user.isAdmin}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="email"
              name="email"
              label="E-mailadres *"
              value={this.state.email}
              onChange={this.handleChange}
              disabled={!credentials.user.isAdmin}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="phone"
              name="phone"
              label="Telefoonnummer *"
              value={this.state.phone}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={9}>
            <TextField
              id="street"
              name="street"
              label="Adres *"
              value={this.state.street}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              id="streetNumber"
              name="streetNumber"
              label="Huisnr. *"
              value={this.state.streetNumber}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="zipcode"
              name="zipcode"
              label="Postcode *"
              value={this.state.zipcode}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="city"
              name="city"
              label="Plaats *"
              value={this.state.city}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="emergencyPerson"
              name="emergencyPerson"
              label="Persoon voor noodgeval *"
              value={this.state.emergencyPerson}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="emergencyPhone"
              name="emergencyPhone"
              label="Telefoonnummer voor noodgeval *"
              value={this.state.emergencyPhone}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            Kledingmaten
          </Grid>
          <Grid item xs={6} sm={3}>
            <InputLabel htmlFor="clothingBlouseSize">Bloes *</InputLabel>
            <Select
              id="clothingBlouseSize"
              name="clothingBlouseSize"
              value={this.state.clothingBlouseSize}
              onChange={this.handleChange}
              fullWidth
            >
              {clothingSizes.map((size) => (
                <MenuItem
                  key={size}
                  value={size}
                  style={{
                    fontWeight:
                      this.state.clothingBlouseSize == size ? "500" : "normal",
                  }}
                >
                  {size}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={6} sm={3}>
            <InputLabel htmlFor="clothingGiletSize">Gilet *</InputLabel>
            <Select
              id="clothingGiletSize"
              name="clothingGiletSize"
              value={this.state.clothingGiletSize}
              onChange={this.handleChange}
              fullWidth
            >
              {clothingSizes.map((size) => (
                <MenuItem
                  key={size}
                  value={size}
                  style={{
                    fontWeight:
                      this.state.clothingGiletSize == size ? "500" : "normal",
                  }}
                >
                  {size}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={6} sm={3}>
            <InputLabel htmlFor="clothingShirtSize">Overhemd *</InputLabel>
            <Select
              id="clothingShirtSize"
              name="clothingShirtSize"
              value={this.state.clothingShirtSize}
              onChange={this.handleChange}
              fullWidth
            >
              {clothingSizes.map((size) => (
                <MenuItem
                  key={size}
                  value={size}
                  style={{
                    fontWeight:
                      this.state.clothingShirtSize == size ? "500" : "normal",
                  }}
                >
                  {size}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={6} sm={3}>
            <InputLabel htmlFor="clothingPoloSize">Polo *</InputLabel>
            <Select
              id="clothingPoloSize"
              name="clothingPoloSize"
              value={this.state.clothingPoloSize}
              onChange={this.handleChange}
              fullWidth
            >
              {clothingSizes.map((size) => (
                <MenuItem
                  key={size}
                  value={size}
                  style={{
                    fontWeight:
                      this.state.clothingPoloSize == size ? "500" : "normal",
                  }}
                >
                  {size}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField
              id="clothingCombatJeansSize"
              name="clothingCombatJeansSize"
              label="Combatbroek *"
              value={this.state.clothingCombatJeansSize}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField
              id="clothingPantSize"
              name="clothingPantSize"
              label="Pantalon *"
              value={this.state.clothingPantSize}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField
              id="clothingShoeSize"
              name="clothingShoeSize"
              label="Schoenen *"
              value={this.state.clothingShoeSize}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
        </Grid>
      </Form>
    );
  }
}

UpdateEmployeeForm.propTypes = {
  employeeEmail: PropTypes.string.isRequired,
  getEmployee: PropTypes.func.isRequired,
  updateEmployee: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage: state.employee.updateEmployee.successMessage,
  errorMessage: state.employee.updateEmployee.errorMessage,
  isFetching:
    state.employee.getEmployee.isFetching ||
    state.employee.updateEmployee.isFetching,
});

export default connect(mapStateToProps, { getEmployee, updateEmployee })(
  UpdateEmployeeForm,
);



// WEBPACK FOOTER //
// ./src/components/forms/UpdateEmployeeForm.js